import { StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PersonalPreferencesActions } from './personal-preferences.action';
import { PersonalPreferencesStateModel } from './personal-preferences.store';

@StateRepository()
@State<PersonalPreferencesStateModel>({ name: 'personalPreferences' })
@Injectable()
export class PersonalPreferencesState extends NgxsDataRepository<PersonalPreferencesStateModel> {
  @Action(PersonalPreferencesActions.SaveGridPaginationPageSize)
  saveGridPaginationPageSize(
    ctx: StateContext<PersonalPreferencesStateModel>,
    { pageSize }: PersonalPreferencesActions.SaveGridPaginationPageSize,
  ) {
    ctx.patchState({
      defaultPageSize: pageSize,
    });
  }

  @Action(PersonalPreferencesActions.SaveGridFilter)
  saveGridFilter(
    ctx: StateContext<PersonalPreferencesStateModel>,
    { gridName, gridFilter }: PersonalPreferencesActions.SaveGridFilter,
  ) {
    ctx.patchState({
      filter: { ...ctx.getState().filter, [gridName]: gridFilter },
    });
  }

  @Action(PersonalPreferencesActions.SaveGridSort)
  saveGridSort(
    ctx: StateContext<PersonalPreferencesStateModel>,
    { gridName, gridSort }: PersonalPreferencesActions.SaveGridSort,
  ) {
    ctx.patchState({
      sort: {
        ...ctx.getState().sort,
        [gridName]: gridSort
          ?.filter(({ sort }) => sort !== null)
          .map(({ colId, sort, sortIndex }) => ({ colId, sort, sortIndex })),
      },
    });
  }

  @Selector()
  static localSavedGridPaginationPageSize(state: PersonalPreferencesStateModel) {
    return state.defaultPageSize;
  }

  // @Selector()
  // static localSavedGridFilter(state: PersonalPreferencesStateModel) {
  //   return (gridName: string) => state.filter?.[gridName];
  // }

  @Selector()
  static localSavedGridFilter(state: PersonalPreferencesStateModel) {
    return state.filter;
  }

  @Selector()
  static localSavedGridSort(state: PersonalPreferencesStateModel) {
    return state.sort;
  }
  // static localSavedGridFilter(gridName: string) {
  //   return createSelector(
  //     [PersonalPreferencesState],
  //     (state: PersonalPreferencesStateModel) => state.filter?.[gridName]
  //   );
  // }
}
